<template>
  <div style="width:100%;overflow-y:auto;overflow-x:hidden;height:100%;">
    <div style="padding:0px;width:100%;">
        <div class="whiteBox dashboard_topic">
            <div class="portlet-title">
                <i class="el-icon-d-arrow-right">&nbsp;</i>新媒体线索成交表
            </div>
            <div class="portlet-content">
                <div class="filter-container" style="padding-top: 0px;">
                    <el-radio-group class="filter-item" size="mini" v-model="listQuery.dateType" @change="listQuery.searchDate = new Date();">
                        <el-radio-button :label="1">按日</el-radio-button>
                        <el-radio-button :label="2">按周</el-radio-button>
                        <el-radio-button :label="3">按月</el-radio-button>
                        <el-radio-button :label="4">按年</el-radio-button>
                        <el-radio-button :label="5">自定义</el-radio-button>
                    </el-radio-group>
                    <el-date-picker key="date" :picker-options="datePickerOption" class="filter-item" size="mini" v-if="listQuery.dateType == 1" :clearable="false" v-model="listQuery.searchDate" type="date" format="yyyy年MM月dd日" placeholder="选择日">
                    </el-date-picker>
                    <el-date-picker key="week" :picker-options="weekDatePickerOption" class="filter-item" size="mini" v-if="listQuery.dateType == 2" :clearable="false" v-model="listQuery.searchDate" type="week" format="yyyy年WW周" placeholder="选择周">
                    </el-date-picker>
                    <el-date-picker key="month" :picker-options="datePickerOption" class="filter-item" size="mini" v-if="listQuery.dateType == 3" :clearable="false" v-model="listQuery.searchDate" type="month" format="yyyy年MM月" placeholder="选择月">
                    </el-date-picker>
                    <el-date-picker key="year" :picker-options="datePickerOption" class="filter-item" size="mini" v-if="listQuery.dateType == 4" :clearable="false" v-model="listQuery.searchDate" type="year" format="yyyy年" placeholder="选择年">
                    </el-date-picker>
                    <el-date-picker key="daterange" :picker-options="datePickerOption"  size="mini" v-if="listQuery.dateType == 5" :clearable="false" v-model="listQuery.dateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                    </el-date-picker>
                    <el-button class="filter-item" size="mini" type="info" icon="el-icon-search" @click="listQuery.page = 1;doSearch()">查看</el-button>
                    <el-button class="filter-item" size="mini" icon="el-icon-refresh" @click="doReset">重置</el-button>
                    <el-button class="filter-item" size="mini" icon="el-icon-download" @click="doExport">导出</el-button>

                </div>
                <el-table :data="list" stripe  id="table" v-loading="listLoading">
                    <el-table-column label="线索" align="center">
                        <el-table-column prop="name" label="线索名" minWidth="120">
                        </el-table-column>
                        <el-table-column prop="phone" label="线索手机号" width="120">
                        </el-table-column>
                        <el-table-column prop="wechatId" label="线索微信号" width="120">
                        </el-table-column>
                        <el-table-column prop="createTime" label="时间" width="135">
                            <template slot-scope="scope">
                                {{ scope.row.createTime ? parseTime(scope.row.createTime, "{y}-{m}-{d} {h}:{i}:{s}") : '' }}
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="sourceName"
                            label="渠道"
                            width="160"
                        >
                          <template #header>
                            <el-select 
                              v-model="listQuery.source" 
                              placeholder="渠道" 
                              size="mini" 
                              multiple
                              collapse-tags
                              style="width: 100%"
                              filterable
                              clearable
                            >
                              <el-option
                                v-for="item in sourceNameList"
                                :key="item.value"
                                :label="item.text"
                                :value="item.value">
                              </el-option>
                            </el-select>
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="flowType"
                          label="流量类型"
                          width="120"
                        >
                          <template #header>
                            <el-select 
                              v-model="listQuery.flowType" 
                              placeholder="流量类型" 
                              size="mini" 
                              multiple
                              collapse-tags
                              style="width: 100%"
                              filterable
                              clearable
                            >
                              <el-option
                                v-for="item in flowTypeList"
                                :key="item.value"
                                :label="item.text"
                                :value="item.value">
                              </el-option>
                            </el-select>
                          </template>
                          <template slot-scope="scope">
                            {{ transformLabel(scope.row.flowType, flowTypeList, 'text', 'value') }}
                          </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column
                      label="清洗邀约"
                      align="center"
                    >
                        <el-table-column prop="finalClearTime" label="最后清洗时间" width="135">
                            <template slot-scope="scope">
                                {{ scope.row.finalClearTime ? parseTime(scope.row.finalClearTime, "{y}-{m}-{d} {h}:{i}:{s}") : '' }}
                            </template>
                        </el-table-column>
                        <el-table-column
                          prop="clueStatusName"
                          label="状态"
                          width="120"
                        >
                          <template #header>
                            <el-select 
                              v-model="listQuery.status" 
                              placeholder="状态" 
                              size="mini" 
                              multiple
                              collapse-tags
                              style="width: 100%"
                              filterable
                              clearable
                            >
                              <el-option
                                v-for="item in clueStatusList"
                                :key="item.value"
                                :label="item.text"
                                :value="item.value">
                              </el-option>
                            </el-select>
                          </template>
                        </el-table-column>
                        <el-table-column prop="clearRemark" label="无效原因" minWidth="80">
                        </el-table-column>
                        <el-table-column
                          prop="clearCount"
                          label="清洗次数"
                          width="120"
                        >
                          <template #header>
                            <el-select 
                              v-model="listQuery.clearCount" 
                              placeholder="清洗次数" 
                              size="mini" 
                              multiple
                              collapse-tags
                              style="width: 100%"
                              filterable
                              clearable
                            >
                              <el-option
                                v-for="item in clearCountList"
                                :key="item.value"
                                :label="item.text"
                                :value="item.value">
                              </el-option>
                            </el-select>
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="clearStaffName"
                          label="清洗人"
                          minWidth="120"
                        >
                          <template #header>
                            <el-select 
                              v-model="listQuery.clearStaff" 
                              placeholder="清洗人" 
                              size="mini" 
                              multiple
                              collapse-tags
                              style="width: 100%"
                              filterable
                              clearable
                            >
                              <el-option
                                v-for="(item, index) in clearStaffNameList"
                                :key="`${item.value}-${index}`"
                                :label="item.text"
                                :value="item.value">
                              </el-option>
                            </el-select>
                          </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="销售" align="center">
                        <el-table-column prop="finalComeTime" label="最后到店时间" width="135">
                            <template slot-scope="scope">
                                {{ scope.row.finalComeTime ? parseTime(scope.row.finalComeTime, "{y}-{m}-{d} {h}:{i}:{s}") : '' }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="orderTime" label="订单时间" width="135">
                            <template slot-scope="scope">
                                {{ scope.row.orderTime ? parseTime(scope.row.orderTime, "{y}-{m}-{d} {h}:{i}:{s}") : '' }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="followRemark" label="战败原因" minWidth="80">
                        </el-table-column>
                        <el-table-column
                          prop="followCount"
                          label="跟进次数"
                          width="80"
                        >
                        </el-table-column>
                        <el-table-column prop="ownerName" label="客户经理" minWidth="80">
                        </el-table-column>
                    </el-table-column>
                </el-table>
                <div class="pagination-container">
                    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit" layout="total, sizes, prev, pager, next, jumper" :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { parseTime } from '@/assets/js/util'

const clearCountList = [
    {text: '0', value: 0},
    {text: '1', value: 1},
    {text: '2', value: 2},
    {text: '3', value: 3},
    {text: '4', value: 4},
    {text: '5', value: 5},
    {text: '6', value: 6},
    {text: '7', value: 7},
    {text: '8', value: 8},
    {text: '9', value: 9},
    {text: '10', value: 10},
    {text: '>10', value: 99},
]
export default {
    data() {
        return {
            sourceNameList: [],
            flowTypeList: [],
            clearCountList,
            clueStatusList: [],
            clearStaffNameList: [],
            parseTime,
            dealer: this.$common.getDealer(),
            list: null,
            listLoading: false,
            aaa: [],
            listQuery: {
                dateType: 1,
                searchDate: new Date(),
                dateRange: [new Date(), new Date()],
                page: 1,
                limit: 10,
                source: [], // 渠道, 多个逗号分隔
                flowType: [], // 流量类型, 多个逗号分隔
                status: [], // 状态, 多个逗号分隔
                clearCount: [], // 清洗次数, 多个逗号分隔, >10用99表示
                clearStaff: [], // 清洗人, 多个逗号分隔
            },
            total: 0,
            datePickerOption: {
                firstDayOfWeek: 1,
                disabledDate(time) {
                    return time.getTime() < new Date('2024-12-31').getTime();
                },
            },
            weekDatePickerOption: {
                firstDayOfWeek: 1,
                disabledDate(time) {
                    return time.getTime() < new Date('2024-12-29').getTime();
                },
            },
            isAdmin: this.$common.getAdmin(),
        };
    },
    mounted() {
        this.retrieveMembers()
        const baseInfo = this.$common.getBaseInfo();
        this.sourceNameList = baseInfo.newMediaClueSources?.map(item => {
            return {text: item.dataDisplay, value: item.dataName}
        })
        this.flowTypeList = baseInfo.flowType?.map(item => {
            return {text: item.dataDisplay, value: item.dataValue}
        })
        this.clueStatusList = baseInfo.onlineRecordStatus?.map(item => {
            return {text: item.dataDisplay, value: item.dataValue}
        })

        this.doSearch();
    },
    methods: {
      retrieveMembers() {
        this.$httpAuth
          .post("/v2/appDealerManagerService/allMembersList", {
            dealerId: this.dealer.dealerId,
          })
          .then((response) => {
            const { data = [] } = response.data;
            // if (!this.isAdmin) {
            //   data.push({
            //     memberId: this.dealer.userId,
            //     userName: this.dealer.name,
            //   });
            // }
            this.clearStaffNameList = data.map(item => {
              return {text: item.memberName, value: item.memberId}
            });;
          });
      },
        handleSizeChange(val) {
            this.listQuery.limit = val
            this.doSearch()
        },
        handleCurrentChange(val) {
            this.listQuery.page = val
            this.doSearch()
        },
        transformLabel(val, list, label = 'dataDisplay', value = 'dataName') {
          const row = list.find(item => item[value] === val);
          return row ? row[label] : '';
        },
        doSearch() {
            this.listLoading = true;
            this.$httpAuth
                .post("/v1/reportRpc/newMediaClueList", {
                    ...this.getParams(),
                    pageStart: (this.listQuery.page - 1) * this.listQuery.limit,
                    pageCount: this.listQuery.limit,
                    isExport: false
                })
                .then((response) => {
                    const data = response.data;
                    this.list = data.data || [];
                    this.listLoading = false;
                    this.total = data.total;
                }).catch(() => {
                    this.listLoading = false;
                });
        },
        doReset() {
            this.list = null;
            this.listLoading = false;
            this.listQuery = {
                dateType: 1,
                searchDate: new Date(),
                dateRange: [new Date(), new Date()],
                page: 1,
                limit: 10,
                source: [],
                flowType: [],
                status: [],
                clearCount: [],
                clearStaff: [],
            };
            this.doSearch();
        },
        doExport() {
            const loading = this.$loading({
                lock: true,
                text: '正在导出中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$httpAuth
                .post("/v1/reportRpc/newMediaClueList", {...this.getParams(), isExport: true})
                .then((response) => {
                    const { file, total } = response.data
                    if (total > 2000) {
                        this.$message({
                            customClass: 'export-message',
                            dangerouslyUseHTMLString: true,
                            message: '<div>应安全要求，一次性最多只能导出2000条数据</div>',
                            duration: 2000
                        });
                    }
                    setTimeout(() => {
                        loading.close()
                        let a = document.createElement('a');
                        a.href = file;
                        a.click();
                    }, 1000);
                })
                .catch(() => {
                    loading.close()
                });
        },
        getParams() {
            const { dateType, searchDate, dateRange, source, flowType, status, clearCount, clearStaff } = this.listQuery;
            let startDate = '';
            let endDate = ''
            if (dateType == 1) {
                startDate = searchDate.Format("yyyy-MM-dd");
                endDate = startDate;
            }
            if (dateType == 2) {
                startDate = this.$common.getFirstDayOfWeek(searchDate);
                endDate = this.$common.getEndDayOfWeek(searchDate);
            }
            if (dateType == 3) {
                startDate = this.$common.getFirstDayOfMonth(searchDate);
                endDate = this.$common.getEndDayOfMonth(searchDate);
            }
            if (dateType == 4) {
                startDate = this.$common.getFirstDayOfYear(searchDate);
                endDate = this.$common.getEndDayOfYear(searchDate);
            }
            if (dateType == 5) {
                if (dateRange.length != 2) {
                    this.$message({
                        message: '请选择时间范围',
                        type: 'warning'
                        });
                    return;
                }
                startDate = dateRange[0].Format("yyyy-MM-dd");
                endDate = dateRange[1].Format("yyyy-MM-dd");
            }
            return {
                dealerId: this.dealer.dealerId,
                dateStart: startDate,
                dateEnd: endDate,
                source: source.toString() || this.sourceNameList.map(item => item.value).toString(),
                flowType: flowType.toString(),
                status: status.toString(),
                clearCount: clearCount.toString(),
                clearStaff: clearStaff.toString(),
            }
        }
    }
}
</script>

<style>

</style>
